<template>
    <tr class="control-table__row contracted-book-card" style="font-size: 14px;">
        <td v-if="!single && !book.is_publish" class="control-table__cell">
            <Checkbox v-model="selected" />
        </td>
        <td class="control-table__cell">
            <router-link :to="`/editor/${book.book.id}`">
                {{ book.book.name }}
            </router-link>
            <div style="font-size: 11px;margin-top: 2px;">ISBN: {{ book.book.isbnx }}</div>
        </td>
        <td class="control-table__cell">{{ book.build_type.label }}</td>
        <td class="control-table__cell">{{ book.contractor.name }}</td>
        <td class="control-table__cell" colspan="2">
            <div style="position: relative; display: flex; align-items: center;">
                <Spinner v-if="loading" />
                <CustomSelect
                    v-model="state"
                    compact
                    class="contracted-book-card__status"
                    :class="{
                        'contracted-book-card__status--red': state === 'initial',
                        'contracted-book-card__status--yellow': state === 'on_ftp',
                        'contracted-book-card__status--green': state === 'completed'
                    }"
                    :options="states"
                    emit-prop="name"
                    view-label="label"
                    width="117px"
                />
                <button
                    style="margin-left: 10px;"
                    class="button"
                    type="button"
                    :disabled="!stateChanged || loading"
                    :class="{ 'is-disabled': !stateChanged }"
                    @click="setState"
                >
                    Ok
                </button>
                <div style="margin-left: 20px;">
                    <button
                        class="button"
                        type="button"
                        style="display:block;"
                        :disabled="loading || state === 'completed'"
                        :class="{ 'is-disabled': state === 'completed' }"
                        @click="sendBook"
                    >
                        {{ $t('adminBookControls.sendFtp') }}
                    </button>
                    <button
                        class="button"
                        type="button"
                        style="margin-top: 10px;"
                        :disabled="loading || state === 'completed'"
                        :class="{ 'is-disabled': state === 'completed' }"
                        @click="sendMeta"
                    >
                        {{ $t('adminBookControls.sendMeta') }}
                    </button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import { mapActions } from 'vuex';

import { CustomSelect, Checkbox } from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'ContractedBookCard',
    components: {
        Checkbox,
        CustomSelect
    },
    props: {
        book: {
            type: Object,
            required: true
        },
        single: {
            type: Boolean,
            default: false
        },
        active: {
            type: Boolean,
            default: false
        },
        states: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            state: ''
        };
    },
    computed: {
        selected: {
            get() {
                return this.active;
            },
            set() {
                this.$emit('selected', {
                    id: this.book.id,
                    book: this.book.book.id,
                    contractor: this.book.contractor.id,
                    isbnx: this.book.book.isbnx,
                    contractorName: this.book.contractor.name
                });
            }
        },
        stateChanged() {
            return this.state !== this.book.state.name;
        }
    },
    watch: {
        'book.state.name': {
            deep: true,
            immediate: true,
            handler(value) {
                this.state = value;
            }
        }
    },
    methods: {
        ...mapActions(['pushToast']),
        async sendMeta() {
            try {
                this.loading = true;

                await this.$http.post(
                    '/api/v1/contractors_books/meta/',
                    {},
                    {
                        params: {
                            id: this.book.id
                        }
                    }
                );

                this.pushToast({
                    id: Date.now(),
                    type: 'success',
                    title: this.$t('adminBookControls.success'),
                    text: this.$t('adminBookControls.metaSuccess')
                });

                this.$emit('metaSent');

                this.loading = false;
            } catch (e) {
                alert(e);
                this.loading = false;
            }
        },
        async sendBook() {
            try {
                this.loading = true;

                await this.$http.post(
                    '/api/v1/contractors_books/ftp/',
                    {},
                    {
                        params: {
                            id: this.book.id
                        }
                    }
                );

                this.pushToast({
                    id: Date.now(),
                    type: 'success',
                    title: this.$t('adminBookControls.success'),
                    text: this.$t('adminBookControls.ftpSuccess')
                });

                this.$emit('bookSent');

                this.loading = false;
            } catch (e) {
                this.loading = false;
                if (e.detail && e.detail[0]) {
                    this.pushToast({
                        id: Date.now(),
                        type: 'error',
                        title: this.$t('adminBookControls.errorFtp'),
                        text: e.detail[0]
                    });
                }
            }
        },
        async setState() {
            try {
                this.loading = true;

                await this.$http.patch(
                    '/api/v1/contractors_books/state/',
                    {
                        state: this.state
                    },
                    {
                        params: {
                            id: this.book.id
                        }
                    }
                );

                this.$emit('statusChanged');

                this.loading = false;
            } catch (e) {
                this.loading = false;
                if (e.detail && e.detail[0]) {
                    this.pushToast({
                        id: Date.now(),
                        type: 'error',
                        title: this.$t('adminBookControls.errorFtp'),
                        text: e.detail[0]
                    });
                }
            }
        }
    }
};
</script>

<style lang="scss" scr="./ContractedBookCard.scss"></style>
